// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1z6ha","addWidgetButton":"Header_addWidgetButton__aO0Ew","dashboardTabs":"Header_dashboardTabs__2w0mf","active":"Header_active__1F7lm"};